import React from "react";
import cn from "classnames";
import styles from "./new-onboarding-stepper.module.scss";
import saveGreenRightIcon from "@src/assets/svg/save-green-right-icon.svg";

const cssClassName = "new-onboarding-stepper";

export type OnboardingStepStatus = "completed" | "active" | "pending";

interface OnboardingStep {
  label: string;
  status: OnboardingStepStatus;
}

interface NewOnboardingStepperProps {
  steps: OnboardingStep[];
}

export const NewOnboardingStepper = ({ steps }: NewOnboardingStepperProps) => {
  return (
    <div className={styles[cssClassName]}>
      {steps.map((step, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={`${step.label}-${index}`}>
          <div className={styles[`${cssClassName}__step`]}>
            <div className={styles[`${cssClassName}__step-icon-wrapper`]}>
              {step.status === "completed" ? (
                <img
                  src={saveGreenRightIcon}
                  alt=""
                  className={styles[`${cssClassName}__step-icon`]}
                />
              ) : (
                <span
                  className={cn(styles[`${cssClassName}__step-dot`], {
                    [styles[`${cssClassName}__step-dot--active`]]:
                      step.status === "active",
                  })}
                />
              )}
            </div>
            <span
              className={cn(styles[`${cssClassName}__step-label`], {
                [styles[`${cssClassName}__step-label--completed`]]:
                  step.status === "completed",
                [styles[`${cssClassName}__step-label--active`]]:
                  step.status === "active",
              })}
            >
              {step.label}
            </span>
          </div>

          {index < steps.length - 1 && (
            <span
              className={cn(styles[`${cssClassName}__connector`], {
                [styles[`${cssClassName}__connector--completed`]]:
                  step.status === "completed",
              })}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
